// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__12C_c","question":"Question_question__2oGGz","description":"Question_description__2_09m"};